/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetStorefrontLoginEntryRequest} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'
import {GetStorefrontLoginEntryResponse} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'


export const getStorefrontLoginEntry = (request: GetStorefrontLoginEntryRequest, options?: CashRequestOptions) => post<GetStorefrontLoginEntryRequest, GetStorefrontLoginEntryResponse>("/2.0/cash/get-storefront-login-entry", request, {...options, rejectOnError: true })